/**
 * How many days ahead a plan reaches. Seven, counted from today.
 *
 * Its own module so screens can read it without importing the generator (and,
 * through the meal-plan slice, Firebase).
 */
export const HORIZON_DAYS = 7;
